export default function () {
  return {
    documentos: [],
    documentosNiveles01: [],
    documentosNiveles02: [],
    documentosNiveles03: []
  }
}
